<template>
  <div>
    <div class="mb-2">
      <a-button @click="$router.back()" class="w-auto">
        Regresar
      </a-button>
    </div>
    <h2 class="text-xl font-bold mb-4">Configuración de Pago</h2>
    <form @submit.prevent="handlePaymentSettings()">
      <div class="flex flex-wrap -mx-2">
        <!-- Primera columna -->
        <div class="w-full md:w-1/2 lg:w-1/2 px-2">
          <a-select
            label="Razón de pago"
            required
            :value="periodPaymentSettings.type"
            class="mb-4"
            id="type"
            :source="paymentReason"
            v-model="periodPaymentSettings.type"
          />

          <a-input
            label="Semestre"
            required
            :value="periodPaymentSettings.target_semester"
            class="mb-4"
            id="target_semester"
            type="number"
            :min="0"
            v-if="periodPaymentSettings.type === 'semester'"
            v-model.number="periodPaymentSettings.target_semester"
          />

          <a-input
            label="Materias"
            required
            :value="periodPaymentSettings.courses_count"
            class="mb-4"
            id="courses_count"
            type="number"
            :min="0"
            v-if="periodPaymentSettings.type === 'courses'"
            v-model.number="periodPaymentSettings.courses_count"
          />

          <!-- <a-input
            label="Valor al contado"
            required
            :value="periodPaymentSettings.full_price"
            class="mb-4"
            id="full_price"
            type="number"
            :min="0"
            :error="error('full_price')"
            v-model.number="periodPaymentSettings.full_price"
          /> -->

          <a-select
            label="Método de pago al contado"
            multiple
            required
            :value="periodPaymentSettings.full_payment_methods"
            class="mb-4"
            id="full_payment_methods"
            :source="paymentOptions"
            v-model="periodPaymentSettings.full_payment_methods"
          />

          <!-- <a-input
            label="Valor a crédito tardío"
            class="mb-4"
            requried
            :value="periodPaymentSettings.credit_price"
            id="credit_price"
            type="number"
            :min="0"
            :error="error('credit_price')"
            v-model.number="periodPaymentSettings.credit_price"
          /> -->

          <a-select
            label="Método de pago a crédito"
            required
            multiple
            :value="periodPaymentSettings.installment_payment_methods"
            class="mb-4"
            id="installment_payment_methods"
            :source="paymentOptions"
            v-model="periodPaymentSettings.installment_payment_methods"
          />

          <a-input
            label="Valor de inscripción y primera mensualidad"
            required
            :value="periodPaymentSettings.initial_price"
            class="mb-4"
            id="initial_price"
            type="number"
            :min="0"
            :error="error('initial_price')"
            v-model.number="periodPaymentSettings.initial_price"
          />
          <a-input
            label="Valor de cada cuota"
            required
            :value="periodPaymentSettings.installments_price"
            class="mb-4"
            id="installments_price"
            type="number"
            :min="0"
            :error="error('installments_price')"
            v-model.number="periodPaymentSettings.installments_price"
          />
        </div>

        <!-- Segunda columna -->
        <div class="w-full md:w-1/2 lg:w-1/2 px-2"> 
          <a-input
            label="Valor pago tardío"
            required
            :value="periodPaymentSettings.late_installment_extra"
            class="mb-4 border-red-400"
            id="late_installment_extra"
            type="number"
            :min="1"
            v-model.number="periodPaymentSettings.late_installment_extra"
          />

          <a-input
            label="Intérvalo para pago tardío"
            required
            placeholder="Cantidad de dias"
            :value="periodPaymentSettings.late_installment_grace_period_days"
            class="mb-4 border-red-400"
            id="late_installment_grace_period_days"
            type="number"
            :min="1"
            v-model.number="
              periodPaymentSettings.late_installment_grace_period_days
            "
          />

          <a-select
            label="Cantidad de cuotas"
            required
            :value="periodPaymentSettings.installments"
            class="mb-4"
            id="installments"
            :source="installmentsOptions"
            v-model="periodPaymentSettings.installments"
          />
          
          <div class="flex flex-wrap gap-2">
            <a-input
              v-for="(date, index) in periodPaymentSettings.installments"
              :key="index"
              :label="`Fecha de cuota ${index + 1}`"
              type="date"
              v-model="periodPaymentSettings.installment_dates[index]"
              :id="`installment_dates[${index}]`"
              class="w-auto"
            />
          </div>
        </div>
      </div>

      <div class="flex space-x-2 mt-4">
        <a-button class="ml-auto mb-4" mode="primary" type="submit">
          {{isUpdating ? "Actualizar" : "Guardar"}}
        </a-button>
        <a-button
          outlined
          class="ml-auto mb-4"
          @click="$router.back()"
        >
          Cancelar
        </a-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      periodPaymentSettings: {
        type: "semester",
        target_semester: null,
        courses_count: null,
        // full_price: 0,
        // credit_price: 0,
        initial_price: 0,
        installments_price: 0,
        late_installment_extra: 0,
        late_installment_grace_period_days: null,
        installments: 1,
        installment_dates: [],
        full_payment_methods: [],
        installment_payment_methods: [],
        period_id: null,
      },
      paymentReason: [
        { value: "semester", label: "Semestre" },
        { value: "courses", label: "Materia" },
      ],
      paymentOptions: [
        { value: 1, label: "Efectivo" },
        { value: 3, label: "Transferencia Bancaria" },
        { value: 5, label: "Zelle" },
      ],
      installmentsOptions: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" },
      ],
      isUpdating: false,
    };
  },
  methods: {
    ...mapActions({
      fetchPeriod: "periods/show",
      store: "periods/store",
      update: "periods/update",
      removeError: "removeError",
      openInscriptionsFromProfile: "periods/openInscriptionsFromProfile",
    }),
    handlePaymentSettings() {
      const newPeriodPaymentSettings = {
        ...this.periodPaymentSettings,
        full_payment_methods: this.periodPaymentSettings.full_payment_methods.map($0 => `${$0}`),
        installment_payment_methods: this.periodPaymentSettings.installment_payment_methods.map($0 => `${$0}`),
      }
      if(this.isUpdating){
        
        const body = {
          ...newPeriodPaymentSettings
        }
        this.$repository.periods.updatePaymentSetting(body.id, body)
          .then(()=>{
            this.$message.success("Se ha actualizado con éxito");
          })
      }else{
        const body = {
          ...newPeriodPaymentSettings,
          period_id: this.$route.params.id,
        };
      
        this.$repository.periods.periodPaymentSettings(body)
          .then(() => {
            this.$message.success("Se ha creado con éxito");
      
            console.log("Formulario enviado correctamente, limpiando valores...");
      
            if (document.getElementById("target_semester")) {
              document.getElementById("target_semester").value = "";
            }
            if (document.getElementById("courses_count")) {
              document.getElementById("courses_count").value = "";
            }
            if (document.getElementById("type")) {
              document.getElementById("type").value = "semester";
            }
            // if (document.getElementById("full_price")) {
            //   document.getElementById("full_price").value = "";
            // }
            // if (document.getElementById("credit_price")) {
            //   document.getElementById("credit_price").value = "";
            // }
            if (document.getElementById("initial_price")) {
              document.getElementById("initial_price").value = "";
            }
            if (document.getElementById("installments_price")) {
              document.getElementById("installments_price").value = "";
            }
            if (document.getElementById("late_installment_extra")) {
              document.getElementById("late_installment_extra").value = "";
            }
            if (document.getElementById("installments")) {
              document.getElementById("installments").value = 1;
            }
            if (document.getElementById("late_installment_grace_period_days")) {
              document.getElementById("late_installment_grace_period_days").value = "";
            }
      
            if (document.getElementById("full_payment_methods")) {
              document.getElementById("full_payment_methods").selectedIndex = -1;
            }
            if (document.getElementById("installment_payment_methods")) {
              document.getElementById("installment_payment_methods").selectedIndex = -1;
            }
            if(document.getElementById("installment_dates[0]")){
              document.getElementById("installment_dates[0]").value = null;
            }
      
            // for (let i = 0; i < this.periodPaymentSettings.installments; i++) {
            //   const installmentDate = document.getElementById(`installment_dates[${i}]`);
            //   if (installmentDate) {
            //     installmentDate.value = "";
            //   }
            // }
      
            this.periodPaymentSettings = {
              type: "semester",
              target_semester: null,
              courses_count: null,
              // full_price: 0,
              // credit_price: 0,
              initial_price: 0,
              installments_price: 0,
              late_installment_extra: 0,
              late_installment_grace_period_days: 0,
              installments: 1,
              installment_dates: [],
              full_payment_methods: [],
              installment_payment_methods: [],
              period_id: null,
            };
          })
          .catch((error) => {
            this.$message.error("Ocurrió un error al crear la configuración de pago");
            console.error("Error al enviar la configuración de pago:", error);
          });
      }
    },
    error(field) {
      return this.periodPaymentSettings[field] === null ? "Este campo es requerido" : "";
    },
  },
  watch: {
    'periodPaymentSettings.installments'(newCount) {
      this.periodPaymentSettings.installment_dates = Array.from(
        { length: newCount },
        (_, i) => this.periodPaymentSettings.installment_dates[i] || ''
      );
    }
  },
  mounted(){
    if(this.$route.params.update){
      this.isUpdating = true;
      this.$repository.periods.getPaymentSetting(this.$route.params.update).then(({data})=>{
        Object.entries(data).forEach(([key, value])=> {
          if(key !== "updated_at"){
            if(key === "full_payment_methods" || key === "installment_payment_methods"){
              if(value.length > 0){
                value.forEach((item)=> {
                  if(this.paymentOptions.find(it => it.value === item)){
                    this.periodPaymentSettings[key].push(Number(item));
                  }
                })
              }
            }else{
              this.periodPaymentSettings[key] = value;
            }
          }
        });
      }) .catch(() => {
      this.$message.error("Ocurrió un error al cargar la informacion");
    });
    }
  }
};
</script>
